import Vue from 'vue'
import UniqueId from 'vue-unique-id'
import VModal from 'vue-js-modal'
// @ts-ignore
import VueCarousel from 'vue-carousel'
import exports = Mocha.interfaces.exports

Vue.use(UniqueId)
Vue.use(VModal)
Vue.use(VueCarousel)

declare const FB: any
declare const gapi: any
declare const ga: any
export var gaNewElem: any = {}
export var gaElems: any = {}

//TODO: if this env redirect to a default pages
if (process.env.VUE_APP_COMING_SOON) {
  if (window.location.pathname !== '/daily-menu.html') {
    window.location.href = '/daily-menu.html'
  }
}

// dev: change by Armando in dec-21 that wasn't merged
// if (window.location.pathname !== '/daily-menu.html'){
//   window.location.href = '/mobile.html'
// }

// window.onload = function mobileDetect(): any {
//   let check: boolean = false
//   ;(function(a): any {
//     if (
//       /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
//         a
//       ) ||
//       /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
//         a.substr(0, 4)
//       )
//     )
//       check = true
//     // @ts-ignore
//   })(navigator.userAgent || navigator.vendor || window.opera)
//   if (check && Number(process.env.VUE_APP_SHOW_MOBILE_VIEW)) {
//     window.location.href = '/mobile.html'
//   }
// }

export class fbConnector {
  constructor() {
    ;(<any>window).fbAsyncInit = () => {
      FB.init({
        appId: '363467184421559',
        cookie: true,
        xfbml: true,
        version: 'v6.0',
      })
      FB.AppEvents.logPageView()
    }
  }

  initFB() {
    const s = 'script'
    const id = 'facebook-jssdk'
    var js: any,
      fjs = document.getElementsByTagName(s)[0]
    if (document.getElementById(s)) return
    js = document.createElement(s)
    js.id = id
    js.async = true
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    let fj = fjs.parentNode
    if (fj === null) return
    fj.insertBefore(js, fjs)
  }
}

export class gmailConnector {
  constructor() {
    ;(<any>window).init = () => {
      gapi.auth2.init({
        client_id: '1060433559342-rab5l0hiviuqb9bqs95376ts2geeolj9.apps.googleusercontent.com',
      })
    }
  }

  initGmail() {
    var po = document.createElement('script')
    po.type = 'text/javascript'
    po.async = true
    po.src = 'https://apis.google.com/js/client.js?onload=init'
    var s = document.getElementsByTagName('script')[0]
    let gm = s.parentNode
    if (gm === null) return
    gm.insertBefore(po, s)
  }
}

export class googleAnalytics {
  gaInit() {
    let currdate: any = new Date()
    ;(<any>window).onLoadCallback = (function (i: any, s: any, o: string, g: string, r: string, a: any, m: any) {
      i['GoogleAnalyticsObject'] = r
      ;(i[r] =
        i[r] ||
        function () {
          ;(i[r].q = i[r].q || []).push(arguments)
        }),
        (i[r].l = 1 * currdate)
      a = s.createElement(o)
      m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga', gaNewElem, gaElems)
    ga('create', 'UA-84644904-2', 'auto')
    ga('send', 'pageview')
  }
}
export function getParameter(name: any, url?: any): any {
  if (!url) url = window.location.href
  name = name.replace('/[[]]/g', '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return ''
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera

  // Check for common mobile indicators in the user agent string
  if (/android/i.test(userAgent)) {
    return true
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && (!window as any).MSStream) {
    return true
  }
  if (/windows phone/i.test(userAgent)) {
    return true
  }
  if (/mobile/i.test(userAgent)) {
    return true
  }

  return false
}

if (isMobile()) {
  console.log('User is on a mobile device')
} else {
  console.log('User is not on a mobile device')
}
